import { useEffect, useState } from 'hono/jsx';
import { api } from '../../lib/api';

export function PaySuccess({ token }: { token: string }) {
  const [details, setDetails] = useState<{ siteName?: string; planName?: string } | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api('/pay/' + token);
        const d = await r.json();
        if (d.status === 'paid' || d.site) {
          setDetails({ siteName: d.site?.name || 'Your Website', planName: d.plan?.name || 'Website Plan' });
        }
      } catch (e) { console.error('Failed to load details', e); }
    })();
  }, [token]);

  return (
    <div class="min-h-screen flex items-center justify-center p-4">
      <div class="w-full max-w-md">
        <div class="bg-dark-800 rounded-xl border border-emerald-500/30 p-8 text-center">
          <div class="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-6">
            <svg class="w-8 h-8 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
            </svg>
          </div>
          <h1 class="text-2xl font-semibold text-slate-100 mb-2">Payment Successful!</h1>
          <p class="text-slate-400 mb-6">Thank you for your payment. Your transaction has been completed.</p>
          <div class="bg-dark-700 rounded-lg p-4 text-left mb-6">
            {!details ? (
              <p class="text-slate-400 text-sm text-center py-2">Loading details…</p>
            ) : (
              <div class="space-y-3">
                <div class="flex justify-between text-sm"><span class="text-slate-400">Site</span><span class="text-slate-200">{details.siteName}</span></div>
                <div class="flex justify-between text-sm"><span class="text-slate-400">Plan</span><span class="text-slate-200">{details.planName}</span></div>
                <div class="flex justify-between text-sm pt-2 border-t border-slate-600/50">
                  <span class="text-slate-300 font-medium">Status</span><span class="text-emerald-400 font-medium">Paid</span>
                </div>
              </div>
            )}
          </div>
          <p class="text-slate-500 text-sm">A confirmation email will be sent to you shortly.<br/>If you have any questions, please contact our support team.</p>
        </div>
        <p class="text-center text-slate-600 text-xs mt-6">Powered by <span class="text-slate-500">WebForCheap</span></p>
      </div>
    </div>
  );
}
